// extracted by mini-css-extract-plugin
export default {"chatPortalContainer":"PortalContainerUtils-module__chatPortalContainer--QCSxu","menuPortalContainer":"PortalContainerUtils-module__menuPortalContainer--MjmMh"};